
  const heroCarousel = document.querySelectorAll('.js-hero-carousel')
  if (heroCarousel.length) {
    heroCarousel.forEach(function (el, index) {
      el.classList.add(`s${index}`);
      new Swiper(`.js-hero-carousel.s${index}`, {
        slidesPerView: 1,
        autoplay: (el.dataset.autoplay == 'true') ? { delay: el.dataset.speed, disableOnInteraction: false } : false,
        effect: "fade",
        a11y: false,
        fadeEffect: {
          crossFade: true
        },
        autoplayDisableOnInteraction: false,
        loop: true,
      })
    })
  } 

class RotatingText extends HTMLElement {
  constructor() {
    super();
    this.currentWordIndex = 0;
    this.animationInProgress = false;
  }
  
  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }
  
  init() {
    this.targetSpan = this.querySelector('span');
    const wordSpeed = this.getAttribute("data-word-speed");
    if (!this.targetSpan) return;
    const allSpans = this.querySelectorAll('span');
    this.wordOptions = Array.from(allSpans).map(span => span.textContent);
    this.animateCharacters(this.targetSpan, this.wordOptions[0]);
    setInterval(() => {
      if (!this.animationInProgress) {
        this.rotateText();
      }
    }, wordSpeed); 
  }
  
  rotateText() {
    if (this.animationInProgress) return;
    
    this.animationInProgress = true;
    const chars = this.targetSpan.querySelectorAll('.char');
    let delay = 0;
    Array.from(chars).forEach((char, i) => {
      setTimeout(() => {
        char.classList.add('blur-out');
        char.classList.remove('clear', 'animated');
      }, 300);
      delay += 60; 
    });
    
    setTimeout(() => {
      this.currentWordIndex = (this.currentWordIndex + 1) % this.wordOptions.length;
      const nextWord = this.wordOptions[this.currentWordIndex];
      this.animateCharacters(this.targetSpan, nextWord);
    });
  }
  
  animateCharacters(element, text) {
    element.innerHTML = text
      .split('')
      .map(char => 
        `<span class="char blur-in">${char === ' ' ? '&nbsp;' : char}</span>`
      )
      .join('');
    const chars = element.querySelectorAll('.char');
    let delay = 0;
    Array.from(chars).forEach((char, i) => {
      setTimeout(() => {
        char.classList.add('animated');
      }, delay);
      delay += 60;
    });
    
    delay = 300; 
    Array.from(chars).forEach((char, i) => {
      setTimeout(() => {
        char.classList.add('clear');
        if (i === chars.length - 1) {
          setTimeout(() => {
            this.animationInProgress = false;
          }, 300);
        }
      }, delay);
      delay += 100;
    });
  }
}

customElements.define('rotating-text', RotatingText);